export enum CloudLabStatus {
  BUILT = 'BUILT',
  BUILD_IN_PROGRESS = 'BUILD_IN_PROGRESS',
  NOT_BUILT = 'NOT_BUILT'
};

export interface CloudLabInfo {
  labStatus: CloudLabStatus
};
